import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormBuilder, ValidatorFn, Validators, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "../../../core/authentication/services/user.service";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { ManagedModalDirective } from "../managed-modal/managed-modal.directive";

export type EventLocation = {
  eventLocationId: number;
  cityId: number;
  cityName: string;
  address: string;
  online: any;
};

function locationIdValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const locationId = control.value;
    if (locationId === null || locationId === undefined) {
      return { nullLocationId: { value: control.value } };
    }
    return null;
  };
}

@Component({
    selector: "app-select-event-location-dialog",
    templateUrl: "./select-event-location-dialog.component.html",
    styleUrls: ["./select-event-location-dialog.component.scss"],
    standalone: true,
    imports: [
        ManagedModalDirective,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
    ],
})
export class SelectEventLocationDialogComponent {
  @Input() locations: EventLocation[];
  @Output() answered = new EventEmitter<number>();

  locationForm = this.fb.group({
    eventLocationId: this.fb.control(null, [
      Validators.required,
      locationIdValidator,
    ]),
  });

  constructor(private fb: FormBuilder) {}

  onConfirmClicked() {
    this.answered.emit(this.locationForm.value.eventLocationId);
  }

  onCancelClicked() {
    this.answered.emit(null);
  }

  getLocations() {
    return this.locations.filter((location) => {
      if (location.online !== "Yes" && location.address) {
        // backwards compability
        return location;
      }
    });
  }
}
